<template>
  <div
    class="notification-item"
    :class="{'clicked':notification.ClickedAt}"
    @click="view"
  >
    <div class="content d-flex">
      <avatar :user="user" />
      <div class="infos">
        <span class="message body-2 lines-2">
          {{notification.Event.Content}} <span v-if="notification.TodoItem">，{{notification.TodoItem.Content}}</span>
        </span>
        <span class="time caption">
          {{notification.CreatedAt | moment}}
        </span>
      </div>
    </div>
    <v-divider />
  </div>
</template>

<script>
import filterMixin from "@/data/filters/filter-mixin.vue";
import redirectMixin from "@/ui/mixin-redirect.vue";
import { mapGetters } from "vuex";
import Avatar from "@/ui/components/avatar.vue";
export default {
  mixins: [filterMixin, redirectMixin],
  components: { Avatar },
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  computed: {
    user() {
      if (!this.notification || !this.notification.Event) return null;
      return this.users.find(o => o.ID == this.notification.Event.UserID);
    },
    ...mapGetters(["users"])
  },
  methods: {
    view() {
      // 1. record
      if (!this.notification.ClickedAt) {
        this.$services.notification.recordClicked(this, this.notification.ID);
      }
      // 2. redirect
      this.redirectToNotification(this.notification);
    }
  }
};
</script>

<style scoped>
.notification-item {
  background-color: #333;
  cursor: pointer;
}
.notification-item.clicked {
  background-color: #111;
}
.notification-item .content {
  padding: 4px;
}
.notification-item .infos {
  margin-left: 4px;
}
.notification-item .time {
  color: #ccc;
}
.lines-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>